import Model from 'src/models/model'
import { computed, ref } from 'vue'

export function useCardPinRequired () {
  const currentCircuit = Model.configuration?.currentCircuit

  /**
   * Determines whether a card scan requires a PIN entry based on the UID's prefix and the current circuit configuration.
   *
   * Checks if the given card UID matches any prefix in the circuit's list of prefixes that require a PIN.
   * If a match is found, returns true; otherwise, false.
   *
   * @param {string} uid The card UID to validate.
   * @returns {boolean} Whether a PIN is required for this card UID.
   */
  function computeCardPinRequired (uid) {
    if (_.isNil(uid)) return false

    const requiredPinPrefixes = currentCircuit.cardPrefixesRequiringPin

    if (_.isEmpty(requiredPinPrefixes)) return false

    const uidFormatted = uid.replace(/[^a-zA-Z0-9]/g, '')

    return _.some(_.keys(requiredPinPrefixes), (prefix) => _.startsWith(uidFormatted, prefix))
  }

  // Create a reactive reference for the UID
  const uid = ref(null)

  // Create a computed property that reacts to UID changes
  const cardPinRequired = computed(() => computeCardPinRequired(uid.value))

  return {
    computeCardPinRequired,
    cardPinRequired,
    uid
  }
}
